var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "19px",
    viewBox: "0 0 21 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9E633E55-2154-4FC8-8923-9809FAA51816") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Approved-Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location-existing-flow-3e",
    transform: "translate(-388.000000, -257.000000)",
    fill: "#444444",
    fillRule: "nonzero",
    stroke: "#444444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(368.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(20.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input-box",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IC/name"
  }, /*#__PURE__*/React.createElement("g", {
    id: "placeholder"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,7.6 C10.5474429,7.6 11.4,6.74744286 11.4,5.7 C11.4,4.65255714 10.5474429,3.8 9.5,3.8 C8.45255714,3.8 7.6,4.65255714 7.6,5.7 C7.6,6.74744286 8.45228571,7.6 9.5,7.6 Z M9.5,4.34285714 C10.2483286,4.34285714 10.8571429,4.95167143 10.8571429,5.7 C10.8571429,6.44832857 10.2483286,7.05714286 9.5,7.05714286 C8.75167143,7.05714286 8.14285714,6.44832857 8.14285714,5.7 C8.14285714,4.95167143 8.75167143,4.34285714 9.5,4.34285714 Z",
    id: "Shape",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48796675,10.654513 L4.68500252,9.5666754 C2.86272681,7.28859336 3.1290346,3.54127947 5.25746019,1.54527379 C6.40590899,0.468114989 7.93250108,-0.125 9.55497973,-0.125 C11.177772,-0.125 12.70437,0.468117307 13.8524925,1.54526743 C15.9822835,3.54255355 16.2460673,7.28975653 14.4207605,9.57158057 L13.6214119,10.6542217 L15.5980905,10.6542217 L15.709549,10.7226354 L19.1114585,17.4234138 L19,17.605 L0,17.605 L-0.111457515,17.4234118 L3.29045198,10.7229248 L3.4019095,10.654513 L5.48796675,10.654513 Z M9.55498067,14.7183026 L13.719063,9.07839808 C15.2994156,7.10225105 15.0753732,3.858031 13.2425808,2.13929343 C12.2578879,1.21600999 10.9487783,0.70738504 9.55529035,0.70738504 C8.16169023,0.70738504 6.85231034,1.21608409 5.86800639,2.13928734 C4.03648803,3.8568302 3.81005861,7.10058832 5.3843826,9.06966936 L5.38731163,9.07348085 L6.59189672,10.7049761 L9.55498067,14.7183026 Z M3.87125603,11.486898 L1.18769882,16.7723236 L17.8123012,16.7723236 L15.128744,11.486898 L13.0069369,11.486898 L9.65554571,16.0267532 L9.454417,16.0267576 L6.10271539,11.486898 L3.87125603,11.486898 Z",
    id: "Shape",
    strokeWidth: 0.25
  })))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1ad22f60ab27ffffff7463b03b0ab8e7.svg";
export { ForwardRef as ReactComponent };